// app-config is replaced with actual config path during build
// eslint-disable-next-line node/no-missing-import
import config from 'app-config';

window.__AppConfiguration = config;
